module.exports = __webpack_public_path__ + "img/base-single-wheel.f1c9d0f1.png";